module.exports = __webpack_public_path__ + "img/ErProgressNote-Icon.1313a9bd.png";